import { atom } from "jotai";

// Last viewed page of the participants list, per study, so navigating back
// from a participant's forms returns to the same page instead of page 1.
export const participantListPageAtom = atom<Record<string, number>>({});
